export default __webpack_public_path__ + "posLoginBanner.png";